import { Routes, Route } from 'react-router-dom';
import SchoolReport from '@/pages/GeniusReport/SchoolReport';
import { SCHOOL_REPORT_PATH } from '@/config/paths';

export function AppRoutes() {
  return (
    <Routes>
      {/* <Route path={LOGIN_PATH} element={<LoginPage />} />
      <Route path={APP_ROOT_PATH} element={<OperationsLayout />}>
        <Route
          index
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
      </Route> */}
      <Route
        path={SCHOOL_REPORT_PATH}
        element={
            <SchoolReport />
        }
      />
      {/* <Route path="*" element={<Navigate to={APP_ROOT_PATH} replace />} /> */}
    </Routes>
  );
}
